import {styled, NavLink} from "@reside/ui";
import {ADMIN_CONTENT_MAX_WIDTH} from "../styles";

export const SubMenu = () => (
  <Menu>
    <MenuInner>
      <NavLink to="/admin/hub-and-spoke/sftp-configurations">
        SFTP Configurations
      </NavLink>
      <NavLink to="/admin/hub-and-spoke/template-fields">
        Template Fields
      </NavLink>
      <NavLink to="/admin/hub-and-spoke/event-triggers">Event Triggers</NavLink>
    </MenuInner>
  </Menu>
);

const Menu = styled.div`
  width: 100%;
  background-color: ${({theme}) => theme.color.white};
  padding: ${({theme}) => `${theme.space[4]}px 0`};
  position: fixed;
  top: 70px;
  height: 60px;
  left: 0;
  box-shadow: ${({theme}) => `${theme.color.gray10} 0 2px ${theme.space[1]}px`};
  z-index: 1;
`;

const MenuInner = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({theme}) => theme.space[6]}px;
  max-width: ${ADMIN_CONTENT_MAX_WIDTH}px;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  @media (max-width: 1170px) {
    padding-left: 15px;
    padding-right: 15px;
  }

  @media (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
  }

  @media (max-width: 460px) {
    padding-left: 7px;
    padding-right: 7px;
  }
`;
